const companyId = process.env.REACT_APP_COMPANY_ID;
console.log(companyId);
export const api_paths = {
  CATEGORY: {
    get: "/category/?pagination=false",
  },
  PROJECT: {
    get: "/project",
  },
  SERVICES: {
    get: "/service/?pagination=false",
  },
  CONTACT: {
    post: "/contact",
  },
  CMS: {
    get: "/cms",
  },
  DEVELOPER: {
    get: `/employee/?company=${companyId}`,
    getDetail: "/employee",
    generatePreview: "/employee/generate-preview",
  },
  PASSKEY: {
    verify: "/passkey/verify",
  },
};
